import { z } from 'zod'

export const updateProfileSchema = z.object({
  userId: z.string().min(1, { message: 'ユーザー情報の取得に失敗しました' }),
  displayName: z.string().trim().min(1, { message: '表示名を入力してください' }),
})

export type UpdateProfileInput = z.infer<typeof updateProfileSchema>
